import React, { Suspense } from 'react'
import Loader from 'components/Loader/Loader'
import Form from 'designer/display/form'
import Page from 'designer/display/page'
import Widget from 'designer/display/widget'

const ExternalComponent = (props) => {
  const { uischema } = props
  const sourceType = uischema.type

  return (
    <Suspense fallback={<Loader />}>
      {sourceType === 'form' && <Form {...props} />}
      {sourceType === 'page' && <Page {...props} />}
      {sourceType === 'widget' && <Widget {...props} />}
    </Suspense>
  )
}

export default ExternalComponent
